import React from "react";

interface CopyIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const CopyIcon: React.FC<CopyIconProps> = ({
  size = 18,
  color = '#292D32',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M12.75 10.55V12.8C12.75 15.8 11.55 17 8.55 17H5.7C2.7 17 1.5 15.8 1.5 12.8V9.95C1.5 6.95 2.7 5.75 5.7 5.75H7.95"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 10.55H10.35C8.55001 10.55 7.95001 9.95 7.95001 8.15V5.75L12.75 10.55Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.70001 2H11.7"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 4.25C5.25 3.005 6.255 2 7.5 2H9.465"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 6.5V11.1425C16.5 12.305 15.555 13.25 14.3925 13.25"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 6.5H14.25C12.5625 6.5 12 5.9375 12 4.25V2L16.5 6.5Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CopyIcon;
